<div>
  <div class='ripple-background'>
    <!-- <div class='circle xxlarge shade1'></div>
    <div class='circle xlarge shade2'></div>
    <div class='circle large shade3'></div>
    <div class='circle mediun shade4'></div>
    <div class='circle small shade5'></div> -->
  
    <div class="glass_container center_glassContainer">
      <p class="imgLogo">
        <img class="imgItem" src="/assets/img/logo Mapix.png">
      </p>
      <div class="center_item">
          <h1 *ngIf="!error">Actualizando Información Geoespacial ...</h1>
          <h1 *ngIf="error">Hubo un error al cargar, regresando...</h1>
      </div>
    </div>
  </div>
</div>